import { CloseSvg, CompleteSvg, ErrorOutlineSvg, WarningSvg } from "@/components/Icon/Icon";
import { ProgressBar } from "@/components/ProgressBar/ProgressBar";
import { Color } from "@/typed/Common";
import { Box, CircularProgress, Collapse, IconButton, Link, SxProps, Theme, Typography, useTheme } from "@mui/material";
import React from "react";

interface StatusBannerProps {
  variant: Color;
  message: React.ReactNode;
  action?: {
    name: string;
    onClick: () => void;
  };
  onClose?: React.MouseEventHandler<HTMLButtonElement>;
  open: boolean;
  closable?: boolean;
  value?: number;
  inprogress?: boolean;
  sx?: SxProps<Theme>;
  icon?: React.ReactNode;
  disableIcon?: boolean;
  borderTop?: boolean;
}

const StatusBanner = ({
  variant,
  message,
  action,
  onClose,
  open,
  closable,
  value,
  inprogress,
  sx,
  icon,
  disableIcon,
  borderTop = false
}: StatusBannerProps) => {
  const theme = useTheme();
  const Icon = () => <>{icon}</>;
  return (
    <Collapse in={open} style={{ minHeight: "unset" }}>
      <Box
        component="div"
        sx={{
          width: "100%",
          backgroundColor: theme.palette[variant].light,
          color: theme.surface.onVariant
        }}
      >
        {value !== undefined && <ProgressBar variant="determinate" rounded={false} color={variant} value={value} height={5} />}
        <Box
          component="div"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: `2px solid ${theme.palette[variant].main}`,
            borderTop: borderTop ? `2px solid ${theme.palette[variant].main}` : undefined,
            minHeight: "2.5em",
            padding: "0 0.5em",
            ...(sx && sx)
          }}
        >
          <Box
            component="div"
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "0.5em"
            }}
          >
            {disableIcon ? (
              <></>
            ) : inprogress ? (
              <CircularProgress color={variant} size="1.15em" sx={{ marginLeft: "3px" }} />
            ) : icon ? (
              <Icon />
            ) : variant === "info" ? (
              <ErrorOutlineSvg color={theme.palette[variant].main} />
            ) : variant === "success" ? (
              <CompleteSvg color={theme.palette[variant].main} />
            ) : variant === "warning" ? (
              <WarningSvg color={theme.palette[variant].main} />
            ) : variant === "error" ? (
              <WarningSvg color={theme.palette[variant].main} />
            ) : null}
            <Typography fontSize={"0.9em"}>{message}</Typography>
            {action && (
              <Link fontSize={"0.9em"} fontWeight={500} component="button" color="inherit" onClick={action.onClick}>
                {action.name}
              </Link>
            )}
          </Box>
          {(closable || closable === undefined) && (
            <IconButton
              onClick={(e) => {
                if (onClose) {
                  onClose(e);
                }
              }}
            >
              <CloseSvg color="inherit" />
            </IconButton>
          )}
        </Box>
      </Box>
    </Collapse>
  );
};

export { StatusBanner };
